import axios from 'axios';
//import config from '../../config';
import {envConfig as config} from '../../environment';

export const gettaleAbstractAll = ()=>{
    const url = `${config.apiUrl}/v1/taleAbstract/`;
    return axios.get(url)
    .then(response => response.data);
 }

export const gettaleAbstractByIdApi = (id)=>{
    const url = `${config.apiUrl}/v1/taleAbstract/${id}`;
    return axios.get(url)
    .then(response => response.data);
 }

 export const gettaleAbstractByUserIdApi = (userId)=>{
   const url = `${config.apiUrl}/v1/taleAbstract/isByUserId/${userId}`;
   return axios.get(url)
   .then(response => response.data);
}

export const gettaleAbstractByTaleIdApi = (taleId)=>{
   const url = `${config.apiUrl}/v1/taleAbstract/byTaleId/${taleId}`;
   return axios.get(url)
   .then(response => response.data);
}

export const deletetaleAbstractByTaleAbstractIdApi = (taleAbstractId)=>{
   const url = `${config.apiUrl}/v1/taleAbstract/${taleAbstractId}`;
   return axios.delete(url)
   .then(response => response.data);
}
 export const posttaleAbstractApi = (taleAbstract)=>{
    const url = `${config.apiUrl}/v1/taleAbstract/`;
    return axios.post(url,taleAbstract)
    .then(response => response.data);
 }

 export const puttaleAbstractApi = (taleAbstract)=>{
    const url = `${config.apiUrl}/v1/taleAbstract/`;
    return axios.put(url,taleAbstract)
    .then(response => response.data);
 }

